/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Nameplaceholder3Inputs */

const en_coinvestments_dataroom_nameplaceholder3 = /** @type {(inputs: Coinvestments_Dataroom_Nameplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Financial Reports`)
};

/**
* | output |
* | --- |
* | "e.g. Financial Reports" |
*
* @param {Coinvestments_Dataroom_Nameplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_nameplaceholder3 = /** @type {((inputs?: Coinvestments_Dataroom_Nameplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Nameplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_nameplaceholder3(inputs)
});
export { coinvestments_dataroom_nameplaceholder3 as "coInvestments_dataRoom_namePlaceholder" }